export default {
  LOGIN_TITLE: 'login-title',
  LOGIN: 'login',
  LOGIN_NOT_A_MEMBER: 'login-not-a-member',
  LOGIN_LABEL_EMAIL: 'login-label-email',
  LOGIN_LABEL_PASSWORD: 'login-label-password',
  LOGIN_BTN_NEXT: 'login-btn-next',
  LOGIN_BTN_BACK: 'login-btn-back',
  LOGIN_WITH_SOCIAL: 'login-with-social',
  LOGIN_VERIFY_IDENTITY: 'login-verify-identity',
  LOGIN_HAS_ACCOUNT_VERIFY_IDENTITY: 'login-has-account-verify-identity',
  LOGIN_FORGOT_PASSWORD: 'login-forgot-password',
  LOGIN_ERROR: 'login-error',
  LOGIN_ERROR_INCORRECT_PASSWORD: 'login-error-incorrect-password',
  LOGIN_ERROR_ACCOUNT_LOCKED: 'login-error-account-locked',
  LOGIN_ERROR_RESET_PASSWORD: 'login-error-reset-password',
  LOGIN_ERROR_RESET_PASSWORD_DOT: 'login-error-reset-password-dot',
  LOGIN_ERROR_WRONG_PASSWORD: 'login-error-wrong-password',

  FORGOTPASSWORD_TITLE: 'forgotpassword-title',
  FORGOTPASSWORD_SUB_TITLE: 'forgotpassword-sub-title',
  FORGOTPASSWORD_BTN_SEND_RESET_LINK: 'forgotpassword-btn-send-reset-link',

  FORGOTPASSWORD_SENT_TITLE: 'forgotpassword-sent-title',
  FORGOTPASSWORD_SENT_SUBTITLE_A: 'forgotpassword-sent-subtitle-a',
  FORGOTPASSWORD_SENT_SUBTITLE_B: 'forgotpassword-sent-subtitle-b',
  FORGOTPASSWORD_SENT_BTN: 'forgotpassword-sent-btn',

  REGISTER_TITLE: 'register-title',
  REGISTER: 'register',
  REGISTER_ALREADY_HAS_ACCOUNT: 'register-already-has-account',
  REGISTER_LABEL_EMAIL: 'register-label-email',
  REGISTER_LABEL_PASSWORD: 'register-label-password',
  REGISTER_LABEL_PASSWORD_AGAIN: 'register-label-password-again',
  REGISTER_PASSWORD_MIN_LENGTH: 'register-password-min-length',
  REGISTER_PASSWORD_CRITERIA: 'register-password-criteria',
  REGISTER_TC_ACKNOWLEDGEMENT: 'register-tc-acknowledgement',
  REGISTER_TC_TERMS_OF_USE: 'register-tc-terms-of-use',
  REGISTER_TC_AND: 'register-tc-and',
  REGISTER_TC_PRIVACY_POLICY: 'register-tc-privacy-policy',
  REGISTER_TC_OPT_OUT_MSG: 'register-tc-opt-out-msg',

  DIVIDER_OR: 'divider-or',
  CONTACT_US: 'contact-us',
  INPUT_SHOW: 'input-show',
  INPUT_HIDE: 'input-hide',
  EMAIL: 'email',
  EMAIL_ALT: 'email-alt',
  BACK: 'back',
  BACK_HOMEPAGE: 'back-homepage',
  PERIOD: 'period',

  ERROR_EMAIL_REQUIED: 'error-email-required',
  ERROR_EMAIL_INVALID: 'error-email-invalid',
  ERROR_EMAIL_EXIST: 'error-email-exist',
  ERROR_EMAIL_IN_USE: 'error-email-in-use',
  ERROR_EMAIL_NOT_MEMBER: 'error-email-not-member',
  ERROR_PASSWORD_REQUIRED: 'error-password-required',
  ERROR_PASSWORD_MIN_LENGTH: 'error-password-min-length',
  ERROR_PASSWORD_WRONG_PATTERN: 'error-password-wrong-pattern',
  ERROR_PASSWORD_MISMATCH: 'error-password-mismatch',
  ERROR_OCCURRED: 'error-occurred',
  ERROR_OCCURRED_SOCIAL: 'error-occurred-social',

  SUCCESS_TITLE: 'success-title',
  SUCCESS_REDIRECT_TEXT: 'success-redirect-text',
  SUCCESS_DESC_CHECK_EMAIL: 'success-desc-check-email',
  SUCCESS_DESC_INFO: 'success-desc-info',
  SUCCESS_DESC_PRIVILEGE: 'success-desc-privilege',

  EMAILSUCCESS_TITLE: 'emailsuccess-title',
  EMAILSUCCESS_SUBTITLE: 'emailsuccess-subtitle',
  EMAILSUCCESS_REDIRECT_TEXT: 'emailsuccess-redirect-text',
  EMAILSUCCESS_REDIRECT_LINK: 'emailsuccess-redirect-link',

  RESETPASSWORD: 'resetpassword',
  RESETPASSWORD_LABEL_EMAIL: 'resetpassword-label-email',
  RESETPASSWORD_LABEL_PASSWORD: 'resetpassword-label-password',
  RESETPASSWORD_LABEL_PASSWORD_AGAIN: 'resetpassword-label-password-again',
  RESETPASSWORD_LABEL_OLD_PASSWORD_DUPLICATED: 'resetpassword-label-old-password-duplicated',

  RESETPASSWORD_SUCCESS_TITLE: 'resetpassword-success-title',
  RESETPASSWORD_SUCCESS_SUBTITLE_A: 'resetpassword-success-subtitle-a',
  RESETPASSWORD_SUCCESS_SUBTITLE_B: 'resetpassword-success-subtitle-b',

  RESETPASSWORD_EXPIRED_SUBTITLE: 'resetpassword-expired-subtitle',
  RESETPASSWORD_EXPIRED_BTN: 'resetpassword-expired-btn',

  INELIGIBLE_BTN: 'ineligible-btn',

  INCIDENT_TITLE: 'incident-title',
  INCIDENT_DESC: 'incident-desc',
  INCIDENT_DESC_UPDATE: 'incident-desc-update',
  INCIDENT_OR: 'incident-or',
  INCIDENT_REGISTER: 'incident-register',
  INCIDENT_ALREADY_HAS_ACCOUNT: 'incident-already-has-account',
  INCIDENT_LOGIN: 'incident-login',
  INCIDENT_FORGOT_PASSWORD: 'incident-forgot-password',
  INCIDENT_RESET_PASSWORD: 'incident-reset-password',
}
